const forEach = Array.prototype.forEach;

// Mouse users
// https://www.w3.org/WAI/tutorials/menus/flyout/#mouse-users
const elems = document.querySelectorAll('.primary-nav__item');

forEach.call(elems, el => {
  el.addEventListener('mouseover', () => {
    el.classList.add('active');
  });

  el.addEventListener('mouseout', () => {
    document.querySelector('.active').classList.remove('active');
  });

  // Keyboard users
  // https://www.w3.org/WAI/tutorials/menus/flyout/#use-button-as-toggle
  const eventType = 'ontouchstart' in document.documentElement === true ? 'touchstart' : 'click';
  el.querySelector('button').addEventListener(eventType, evt => {
    if (evt.target.parentNode.classList.contains('active')) {
      evt.target.parentNode.classList.remove('active');
      evt.target.setAttribute('aria-expanded', 'false');
    } else {
      evt.target.parentNode.classList.add('active');
      evt.target.setAttribute('aria-expanded', 'true');
    }
  });
});
